import axios from '@/plugins/axios';

export function createDataChangeRequest(data, config) {
    return axios.post('/data-change-requests', data, config);
}